
  import TocList from '@/components/TocList'
  export default {
    components: {
      TocList
    },
    props: {
      items: {
        default: []
      }
    },
    data() {
      return {

      }
    },

  }
